/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Step3_TitleInputs */

const en_serve_step3_title = /** @type {(inputs: Serve_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Connect your computer to Bystep`)
};

const id_serve_step3_title = /** @type {(inputs: Serve_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Sambungkan komputermu ke Bystep`)
};

/**
* | output |
* | --- |
* | "3. Connect your computer to Bystep" |
*
* @param {Serve_Step3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_step3_title = /** @type {((inputs?: Serve_Step3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Step3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_step3_title(inputs)
	return en_serve_step3_title(inputs)
});